module.exports = new __parcel__URL__("bossfight_defeat_return_home_button.51c8911f.png").toString();